import { useEffect, useRef, useState } from 'react';
import styles from './About.module.css';

const About = () => {
	const [transition, setTransition] = useState(false);
	const descriptionRef = useRef<HTMLHeadingElement>(null);

	useEffect(() => {
		const observer = new IntersectionObserver((entries) => {
			const entry = entries[0];
			if (entry.isIntersecting) {
				setTransition(true);
			}
		});

		const currentRef = descriptionRef.current;
		if (currentRef) {
			observer.observe(currentRef);
		}

		return () => {
			if (currentRef) {
				observer.unobserve(currentRef);
			}
		};
	}, []);

	return (
		<section className={styles.section} id="about">
			<h2 className={styles.title} ref={descriptionRef}>
				About
			</h2>
			<p className={`${styles.description} ${transition ? styles['inView'] : ''}`}>
				I'm a frontend developer with a passion for creating beautiful and functional web
				applications. I love working with React and exploring new technologies. Most I know
				is self-taught, but recently I graduated from Fagskolen Kristiania in Oslo, Norway,
				with a Higher Vocational degree in Frontend Development.
			</p>
		</section>
	);
};

export default About;
